module.exports = __webpack_public_path__ + "img/NewCarIcon.c9b81eb8.svg";